import { FunctionComponent, useEffect, useRef, useState } from 'react';
import getConfig from 'next/config';
import classnames from 'classnames';

import Button, { ButtonElements, ButtonIconPositions, ButtonIconTypes, ButtonVariants } from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicSectionSeoDescriptionVariantDefault: FunctionComponent<Props> = ({ translations }) => {
    if (translations && Object.keys(translations).length === 0) return null;

    const [isExpandable, setIsExpandable] = useState<boolean>(false);
    const [expanded, setExpanded] = useState<boolean>(false);
    const descriptionRef = useRef(null);
    const headlineRef = useRef(null);
    const { publicRuntimeConfig } = getConfig();
    const appLocale = publicRuntimeConfig.APP_LOCALE;

    useEffect(() => {
        if (descriptionRef.current) {
            const descriptionHeight = descriptionRef.current.getBoundingClientRect().height;
            const fontSize16WithLineHeight = 24;
            const fontSize14WithLineHeight = 21;

            if (window.innerWidth >= 640 && (descriptionHeight > (fontSize16WithLineHeight * 4))) setIsExpandable(true);
            if (window.innerWidth < 640 && (descriptionHeight > fontSize14WithLineHeight * 4)) setIsExpandable(true);
        }
    }, [translations]);

    const onExpandClick = (): void => {
        setExpanded(!expanded);

        if (expanded) {
            headlineRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        }
    };

    return (
        <StyledComponent className="public-section-seo-description-variant-default">
            <LayoutContainer>
                {translations?.headline && (
                    <div
                        className="headline"
                        ref={headlineRef}
                        dangerouslySetInnerHTML={{ __html: translations?.headline }}
                    />
                )}
                {translations?.description && (
                    <>
                        <div
                            className={classnames({
                                'description-wrapper': true,
                                'expanded': expanded,
                                'expandable': isExpandable,
                            })}
                        >
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: translations.description.replace(/\n/g, '<br>') }}
                                ref={descriptionRef}
                            />
                        </div>
                        {isExpandable && (
                            <Button
                                className="expand-button"
                                onClick={() => onExpandClick()}
                                icon={{
                                    value: '/images/home/arrow-down.svg',
                                    position: ButtonIconPositions.After,
                                    type: ButtonIconTypes.Image,
                                }}
                                variant={ButtonVariants.Outline}
                                element={ButtonElements.Button}

                            >
                                {expanded
                                    ? appLocale === 'pl' ? 'Zwiń' : 'Hide'
                                    : appLocale === 'pl' ? 'Zobacz wiecej' : 'Read more'
                                }
                            </Button>
                        )}
                    </>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionSeoDescriptionVariantDefault;
